import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'ScoreIndicator',
  label: 'Score Indicator',
  icon: 'DocumentTextIcon',
  description: 'Fields for a score indicator',
  properties: [
    {
      label: 'Percentage',
      name: 'percent',
      editor: 'number',
      readonly: false,
      description: 'The percentage score',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
